import Furniture from './Furniture';

const STATE_IDLE = 1;
const STATE_BUTTERFLY_APPEAR = 2;
const STATE_BUTTERFLY_IDLE = 3;
const STATE_BUTTERFLY_LEAVE = 4;

export default class Pampas extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = STATE_IDLE;
    this.isButterfly = true;

    //
    this.asset.setMixByName('1_idle', '2_ladybird_appear', 0.2);
    this.asset.setMixByName('2_ladybird_appear', '3_ladybird_loop', 0.2);
    this.asset.setMixByName('3_ladybird_loop', '4_ladybird_leave', 0.2);
    this.asset.setMixByName('1_idle', '5_moth_appear', 0.2);
    this.asset.setMixByName('5_moth_appear', '6_moth_loop', 0.2);
    this.asset.setMixByName('6_moth_loop', '7_moth_leave', 0.2);
    this.setAnim('1_idle');
  }

  updateBounds() {
    this.bb = this.getBounds();
    this.bb.height = 150;
  }

  setDay() {
    if (this.state === STATE_BUTTERFLY_IDLE && !this.isButterfly) {
      this.handleInputDown();
    }
  }

  setNight() {
    if (this.state === STATE_BUTTERFLY_IDLE && this.isButterfly) {
      this.handleInputDown();
    }
  }

  //
  handleInputDown() {
    if (this.state === STATE_IDLE) {
      this.state = STATE_BUTTERFLY_APPEAR;
      this.asset.onComplete.add(this.handleAnimAppear, this);
      if (this.location.isDay()) {
        this.isButterfly = true;
        this.setAnim('2_ladybird_appear', false);
      } else {
        this.isButterfly = false;
        this.setAnim('5_moth_appear', false);
      }

      this.game.sounds.playSFX('item_flowers', { spriteID: 'sfx' });
    } else if (this.state === STATE_BUTTERFLY_IDLE) {
      this.state = STATE_BUTTERFLY_LEAVE;
      this.asset.onComplete.add(this.handleAnimLeave, this);
      if (this.isButterfly) {
        this.setAnim('4_ladybird_leave', false);
      } else {
        this.setAnim('7_moth_leave', false);
      }

      this.game.sounds.playSFX('item_flowers', { spriteID: 'sfx' });
    }
  }

  handleAnimAppear(trackEntry) {
    if (trackEntry.trackIndex === 0) {
      this.state = STATE_BUTTERFLY_IDLE;
      this.asset.onComplete.remove(this.handleAnimAppear, this);
      if (this.isButterfly) {
        if (this.location.isDay()) {
          this.setAnim('3_ladybird_loop');
        } else {
          this.handleInputDown();
        }
      } else if (!this.location.isDay()) {
        this.setAnim('6_moth_loop');
      } else {
        this.handleInputDown();
      }
    }
  }

  handleAnimLeave(trackEntry) {
    if (trackEntry.trackIndex === 0) {
      this.asset.onComplete.remove(this.handleAnimLeave, this);
      this.state = STATE_IDLE;
      this.setAnim('1_idle');
    }
  }
}
